import { classNames } from 'shared/lib/classNames/classNames';
import { useSelector } from 'react-redux';
import { getPlotStepData } from 'widgets/PlotSteps';
import { Buttons } from 'features/StepActions/ui/Buttons';
import { SpeechBox } from 'entities/SpeechBox';
import cls from './SmsView.module.scss';

interface SmsViewProps {
    className?: string
}

export const SmsView = (props: SmsViewProps) => {
    const {
        className,
    } = props;
    const stepData = useSelector(getPlotStepData);

    return (
        <div className={classNames(cls.SmsView, {}, [className])}>
            <div className={classNames(cls.actionContent, { [cls.withSms]: stepData?.action?.smsText }, [className])}>
                <img className={cls.img} src={stepData?.action?.centerImg} alt="Телефон" />
                {stepData?.action?.smsText
                    && (
                        <SpeechBox
                            className={cls.speechBox}
                            name={stepData?.action?.name}
                            message={stepData?.action?.smsText}
                        />
                    )}
            </div>
            <div className={cls.buttonBox}>
                <Buttons />
            </div>
        </div>
    );
};
